import React from "react";
import { Link } from "@/components/common/Link";
import { Button } from "@/components/ui/button";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
import { ArrowRight } from "lucide-react";
export default function ClaimYourProperty() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll();
  return <section id="claim-your-property" className="dark bg-background text-foreground">
      <div className="w-full bg-primary py-24 md:py-32 lg:py-40 px-4 flex flex-col items-center justify-center text-center overflow-hidden relative">
        {}
        
        <div ref={ref} className={cn("max-w-5xl mx-auto flex flex-col items-center transition-all duration-700 ease-out transform", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-10")}>
          <h2 className="font-serif text-5xl md:text-7xl lg:text-8xl font-black tracking-tighter uppercase text-black mb-6 leading-[0.9]">
            Claim Your <br className="hidden md:block" /> Land Back.
          </h2>
          
          <p className="text-lg md:text-2xl font-bold text-black/80 max-w-2xl mb-10 leading-relaxed">
            Get your free estimate and site evaluation today.
          </p>

          <Button asChild size="lg" className="h-20 px-12 text-xl md:text-2xl font-black uppercase bg-black text-white hover:bg-white hover:text-black border-4 border-black rounded-none transition-all duration-300 shadow-[8px_8px_0px_0px_rgba(0,0,0,0.25)] hover:shadow-none hover:translate-x-[4px] hover:translate-y-[4px]">
            <Link to="/GetAQuotePage">
              Get Started Now
              <ArrowRight className="ml-3 size-8 stroke-[3]" />
            </Link>
          </Button>
        </div>
      </div>
    </section>;
}